const neurotransmitter_sp = {
    'dopamine_sp': {
        'Bacillus genus': 0,
        'Candida albicans': 0,
        'Clostridium difficile': 0,
        'Escherichia coli': 0,
        'Staphylococcus aureus': 0,
        'Akkermansia muciniphila': 0.25,
        'Alistipes putredinis': 1,
        'Bacteroides genus': 1,
        'Bacteroides fragilis': 1,
        'Faecalibacterium prausnitzii': 1,
        'Roseburia hominis': 1,
        'Bifidobacterium bifidum': 1,
        'Bifidobacterium breve': 0,
        'Bifidobacterium lactis': 0.5,
        'Bifidobacterium longum': 2,
        'Lactobacillus acidophilus': 0,
        'Lactobacillus gasseri': 0.5,
        'Lactobacillus helveticus': 0.5,
        'Lactobacillus paracasei': 1,
        'Lactobacillus plantarum': 1,
        'Lactobacillus reuteri': 0.5,
        'Lactobacillus rhamnosus': 0.5,
        'Streptococcus thermophilus': 1
    },
    'gaba_sp': {
        'Bacillus genus': 0,
        'Candida albicans': 0,
        'Clostridium difficile': 0.25,
        'Escherichia coli': 0,
        'Staphylococcus aureus': 0,
        'Akkermansia muciniphila': 0.5,
        'Alistipes putredinis': 1,
        'Bacteroides genus': 1,
        'Bacteroides fragilis': 1,
        'Faecalibacterium prausnitzii': 0,
        'Roseburia hominis': -1,
        'Bifidobacterium bifidum': 1,
        'Bifidobacterium breve': 0,
        'Bifidobacterium lactis': 0.5,
        'Bifidobacterium longum': 2,
        'Lactobacillus acidophilus': 0,
        'Lactobacillus gasseri': 0.5,
        'Lactobacillus helveticus': 0.5,
        'Lactobacillus paracasei': 1,
        'Lactobacillus plantarum': 1,
        'Lactobacillus reuteri': 0.5,
        'Lactobacillus rhamnosus': 0.5,
        'Streptococcus thermophilus': 1
    },
    'serotonin_sp': {
        'Bacillus genus': 0,
        'Candida albicans': 0,
        'Clostridium difficile': 0,
        'Escherichia coli': 0,
        'Staphylococcus aureus': 0,
        'Akkermansia muciniphila': 0.25,
        'Alistipes putredinis': 1,
        'Bacteroides genus': 1,
        'Bacteroides fragilis': 1,
        'Faecalibacterium prausnitzii': 1,
        'Roseburia hominis': 1,
        'Bifidobacterium bifidum': 1,
        'Bifidobacterium breve': 0,
        'Bifidobacterium lactis': 0.5,
        'Bifidobacterium longum': 2,
        'Lactobacillus acidophilus': 0,
        'Lactobacillus gasseri': 0.5,
        'Lactobacillus helveticus': 0.5,
        'Lactobacillus paracasei': 1,
        'Lactobacillus plantarum': 1,
        'Lactobacillus reuteri': 0.5,
        'Lactobacillus rhamnosus': 0.5,
        'Streptococcus thermophilus': 1
    }
}

const neurotransmitter_multi = {
    case1: {
        score_cal: 5,
        multiply: 1.25
    },
    case2: {
        score_cal: 4,
        multiply: 1.15
    },
    case3: {
        score_cal: 3,
        multiply: 1
    },
    case4: {
        score_cal: 2,
        multiply: 0.5
    },
    case5: {
        score_cal: 1,
        multiply: 0.25
    },
    othercase: {
        multiply: 0
    },
}

const neurotransmitter_spCondition = {
    dopamine: {
        page: 41,
        XposText: 488,
        YposText: 516,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 52,
        YposImage: 470,
        xBarStart: 146,
        YBarStart: 522,
        xBarGap: 64,
        yOffset: 200,
        conditions: [
            {
                condition: (x) => x >= 10,
                score: 3,
                label: 'Optimum',
                image: 'd3',
            },
            {
                condition: (x) => (2.75 < x) && (x < 10),
                score: 2,
                label: 'Slightly below optimum',
                image: 'd2',
            },
            {
                condition: (x) => x <= 2.75,
                score: 1,
                label: 'Below optimum',
                image: 'd1',
            }
        ]
    },
    gaba: {
        page: 41,
        XposText: 488,
        YposText: 613,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 53,
        YposImage: 566,
        xBarStart: 146,
        YBarStart: 618,
        xBarGap: 64,
        yOffset: 240,
        conditions: [
            {
                condition: (x) => x >= 8.5,
                score: 3,
                label: 'Optimum',
                image: 'g3',
            },
            {
                condition: (x) => (2.3 < x) && (x < 8.5),
                score: 2,
                label: 'Slightly below optimum',
                image: 'g2',
            },
            {
                condition: (x) => x <= 2.3,
                score: 1,
                label: 'Below optimum',
                image: 'g1',
            }
        ]
    },
    serotonin: {
        page: 41,
        XposText: 488,
        YposText: 714,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 52,
        YposImage: 668,
        xBarStart: 146,
        YBarStart: 719,
        xBarGap: 64,
        yOffset: 280,
        conditions: [
            {
                condition: (x) => x >= 10,
                score: 3,
                label: 'Optimum',
                image: 's3',
            },
            {
                condition: (x) => (2.75 < x) && (x < 10),
                score: 2,
                label: 'Slightly below optimum',
                image: 's2',
            },
            {
                condition: (x) => x <= 2.75,
                score: 1,
                label: 'Below optimum',
                image: 's1',
            }
        ]
    }
}

const neurotransmitter_spCondition_thai = {
    dopamine: {
        page: 40,
        XposText: 516,
        YposText: 531,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 78,
        YposImage: 483,
        xBarStart: 178,
        YBarStart: 540,
        xBarGap: 64,
        yOffset: 200,
        conditions: [
            {
                condition: (x) => x >= 10,
                score: 3,
                label: 'เหมาะสม',
                image: 'd3',
            },
            {
                condition: (x) => (2.75 < x) && (x < 10),
                score: 2,
                label: 'ต่ำกว่าระดับที่เหมาะสมเล็กน้อย',
                image: 'd2',
            },
            {
                condition: (x) => x <= 2.75,
                score: 1,
                label: 'ต่ำกว่าระดับที่เหมาะสม',
                image: 'd1',
            }
        ]
    },
    gaba: {
        page: 40,
        XposText: 516,
        YposText: 626,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 78,
        YposImage: 585,
        xBarStart: 178,
        YBarStart: 636,
        xBarGap: 64,
        yOffset: 240,
        conditions: [
            {
                condition: (x) => x >= 8.5,
                score: 3,
                label: 'เหมาะสม',
                image: 'g3',
            },
            {
                condition: (x) => (2.3 < x) && (x < 8.5),
                score: 2,
                label: 'ต่ำกว่าระดับที่เหมาะสมเล็กน้อย',
                image: 'g2',
            },
            {
                condition: (x) => x <= 2.3,
                score: 1,
                label: 'ต่ำกว่าระดับที่เหมาะสม',
                image: 'g1',
            }
        ]
    },
    serotonin: {
        page: 40,
        XposText: 516,
        YposText: 726,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 78,
        YposImage: 687,
        xBarStart: 178,
        YBarStart: 735,
        xBarGap: 64,
        yOffset: 280,
        conditions: [
            {
                condition: (x) => x >= 10,
                score: 3,
                label: 'เหมาะสม',
                image: 's3',
            },
            {
                condition: (x) => (2.75 < x) && (x < 10),
                score: 2,
                label: 'ต่ำกว่าระดับที่เหมาะสมเล็กน้อย',
                image: 's2',
            },
            {
                condition: (x) => x <= 2.75,
                score: 1,
                label: 'ต่ำกว่าระดับที่เหมาะสม',
                image: 's1',
            }
        ]
    }
}

export { neurotransmitter_sp, neurotransmitter_multi, neurotransmitter_spCondition, neurotransmitter_spCondition_thai };